export default __webpack_public_path__ + "static/media/Chestguard of Reckless Challenge.1327bbe4.jpg";